/**
 * Created by 唐亦慧 on 2017/8/31.
 */
import Reflux from 'reflux';

export const productActions = Reflux.createActions([
	'paramChange',
	'changeValue',
	'changePay',
	'useStoreChange',
	'searchChange'
]);

export class productStore extends Reflux.Store {
	constructor() {
		super();
		this.state = {
			useStore: false,
			storeData: {
				active: 1,
				categoryId: '',
				orderField: 'view_count',
				orderString: 'desc',
				keyword: '',
				barCode: '',
				p: 1,
				s: 10
			},
			searchMallData: {
				name: '',
				proBigType: '',
				proMiddleType: '',
				proDetailType: '',
				seriesCode: '',
				isHot: '1',
				isNew: '1',
				p: 1,
				s: 10,
			},
			maxKeyValue: '',
			minKeyValue: ''
		}
		this.listenables = productActions;
	}

	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data) {
		this.setState({
			...this.state,
			storeData: {
				...this.state.storeData,
				...data
			}
		});
	}

	searchChange(data) {
		this.setState({
			...this.state,
			searchMallData: {
				...this.state.searchMallData,
				...data
			}
		});
	}

	changeValue(name, value) {
		this.setState({
			...this.state,
			[name]: value
		})
	}
}



// WEBPACK FOOTER //
// ./src/mall/mallHome/store.js